// saga.js
import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import scrumBoardActions from './actions'
import DemoData from './data'
import { loadState, saveState } from '../../helpers/localStorage'
import {
    getListTask,
    updateTaskStatusAPI,
    createNewTask,
    getTaskByIdAPI,
    updateTaskAPI,
    MakeStarForTask,
    DeleteStarForTask,
    getListTaskStar,
    sendTaskAPI,
    getActivityTask,
    getRankingInTask,
    getListTaskByHashTag,
    getListTaskOfUser,
    getListTaskAboutTime,
    getListTaskMergeQuery,
} from '../../services/apis/TaskApiServices'
import { getListUser } from '../../services/apis/OrganizationsAPIService'
import { getAllListHashTag } from '../../services/apis/HastagServices'
import {getListUsers, getUserByArray} from '../../services/apis/UserAPIServices'
import {
    createNewReport,
    sendReportToTask,
    updateStatusReport,
    getListReportComment,
    commentReport,
    updateReportReworkAPI,
    updateScoreReport,
} from '../../services/apis/ReportAPIServices'
import { searchTasks } from '../../services/apis/SearchService'
import { getListEventQuery } from '../../services/apis/EventAPIServices'
import { getListObjectQuerybyid } from '../../services/apis/ObjectAPIServices'
import { HandleErrorCode } from '../handleErrorCode/index'
import { notification } from 'antd'
import actions from '../organization/actions'
import { getListReportQueryById } from '../../services/apis/ReportAPIServices'

const getScrumBoards = state => state.scrumBoard

function getColumnId(status) {
    if (status === 'Sent') {
        return 'column2'
    }
    if (status === 'Watched') {
        return 'column3'
    }
    if (status === 'Rework') {
        return 'column4'
    }
    if (status === 'Approved') {
        return 'column5'
    }
}

function* saga_getListTaskMergeOption(action) {
    try {
        const { page_number, page_size, body } = action.payload
        const request = yield call(
            getListTaskMergeQuery,
            page_number,
            page_size,
            body
        )
        console.log('get data merge option', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.updateTotalPage(request.total))
            const ListTask = request.data

            let Board = []
            yield ListTask.map(data => {
                let value = {
                    avatar: data.avatar,
                    deadline: data.deadline,
                    star: data.star,
                    id: data.task_id,
                    column_orders: [
                        'column1',
                        'column2',
                        'column3',
                        'column4',
                        'column5',
                    ],
                    title: data.name,
                    content: data.note,
                    process: data.process,
                    editing: true,
                    created_at: data.create_time,
                    updated_at: '',
                    lstReportID: data.lstReportID,
                    lst_event_id: data.lst_event_id,
                    lst_object_id: data.lst_object_id,
                    lst_uid_receive: data.lst_uid_receive,
                    lst_hashtag: data.lst_hashtag,
                    lst_organ_receive_id: data.lst_organ_receive_id,
                    lst_media: data.lst_media,
                    status: data.status,
                    owner_id: data.owner_id,
                    background_url: data.background_url,
                }
                Board.push(value)
            })

            yield put(
                scrumBoardActions.setBoardData({
                    boards: Board,
                })
            )
        } else {
            yield put(
                scrumBoardActions.setBoardData({
                    boards: [],
                })
            )
        }
    } catch (ex) {
        console.log('get list ranking: ', ex.message)
    }
}

function* saga_getListTaskAboutTime(action) {
    try {
        const { page_number, page_size, begin_time, end_time } = action.payload
        const request = yield call(
            getListTaskAboutTime,
            page_number,
            page_size,
            begin_time,
            end_time
        )
        console.log('get data by time', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.updateTotalPage(request.total))
            const ListTask = request.data

            let Board = []
            yield ListTask.map(data => {
                let value = {
                    avatar: data.avatar,
                    deadline: data.deadline,
                    star: data.star,
                    id: data.task_id,
                    column_orders: [
                        'column1',
                        'column2',
                        'column3',
                        'column4',
                        'column5',
                    ],
                    title: data.name,
                    content: data.note,
                    process: data.process,
                    editing: true,
                    created_at: data.create_time,
                    updated_at: '',
                    lstReportID: data.lstReportID,
                    lst_event_id: data.lst_event_id,
                    lst_object_id: data.lst_object_id,
                    lst_uid_receive: data.lst_uid_receive,
                    lst_hashtag: data.lst_hashtag,
                    lst_organ_receive_id: data.lst_organ_receive_id,
                    lst_media: data.lst_media,
                    status: data.status,
                    owner_id: data.owner_id,
                    background_url: data.background_url,
                }
                Board.push(value)
            })

            yield put(
                scrumBoardActions.setBoardData({
                    boards: Board,
                })
            )
        } else {
            yield put(
                scrumBoardActions.setBoardData({
                    boards: [],
                })
            )
        }
    } catch (ex) {
        console.log('get list ranking: ', ex.message)
    }
}

function* saga_getCurrentListUser(action) {
    try {
        const { lstuser } = action.payload
        const request = yield call(getUserByArray, lstuser)
        console.log('searchuser by text', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.getListCurrentUserDone(request.data))
        }else{
            yield put(scrumBoardActions.getListCurrentUserDone([]))

        }
    } catch (ex) {
        console.log('get current user error: ', ex.message)
    }
}

function* saga_searchUserByText(action) {
    try {
        const { text } = action.payload
        const request = yield call(getListUsers, 1, 10, 1, text)
        console.log('searchuser by text', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.searchUserByTextDone(request.data))
        }else{
            yield put(scrumBoardActions.searchUserByTextDone([]))

        }
    } catch (ex) {
        console.log('search user by text error: ', ex.message)
    }
}

function* saga_getListRankingInTask(action) {
    try {
        const { tid } = action.payload
        const request = yield call(getRankingInTask, tid)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.getListRankingDone(request.data))
        }
    } catch (ex) {
        console.log('get list ranking: ', ex.message)
    }
}

function* saga_updateScoreReport(action) {
    try {
        const { rid, score } = action.payload
        const request = yield call(updateScoreReport, rid, score)
        if (request.error.code === 200) {
            console.log('update score report success')
        }
    } catch (ex) {
        console.log('update score report : ', ex.message)
    }
}

function* saga_updateStatusTask(action) {
    try {
        const { task_id, status } = action.payload
        const request = yield call(updateTaskStatusAPI, task_id, status)
        if (request.error.code === 200) {
            console.log('update status task ' + task_id + 'success')
            if (status === 3) {
                notification.success({
                    message: 'Đã yêu cầu các đơn vị thực hiện nhiệm vụ này',
                })
            }
            if (status === 4) {
                notification.success({
                    message: 'Nhiệm vụ đã kết thúc',
                })
            }

            yield put(scrumBoardActions.getDetailTaskById(task_id))
        } else {
            HandleErrorCode(request.error.code)
        }
    } catch (ex) {
        console.log('update status task : ', ex.message)
    }
}

function* saga_getListHashTagAll(action) {
    try {
        const request = yield call(getAllListHashTag)
        console.log('listHashTagAll data', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.getListHashTagAllDone(request.data))
        }
    } catch (ex) {
        console.log('get list all hash tag  : ', ex.message)
    }
}

function* saga_getListTaskActivity(action) {
    try {
        const { tid, page_number, page_size } = action.payload
        const request = yield call(getActivityTask, tid, page_number, page_size)
        console.log('get list activity task', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.getActivityTaskDone(request.data))
        } else {
            yield put(scrumBoardActions.getActivityTaskDone([]))
        }
    } catch (ex) {
        console.log('get activity task  : ', ex.message)
    }
}

function* saga_searchTaskByHashTag(action) {
    try {
        const { page_number, page_size, hashtag } = action.payload
        const request = yield call(
            getListTaskByHashTag,
            page_number,
            page_size,
            hashtag.trim()
        )
        console.log('search task by hashtag request', hashtag)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.updateTotalPage(request.total))
            const ListTask = request.data

            let Board = []
            yield ListTask.map(data => {
                let value = {
                    avatar: data.avatar,
                    deadline: data.deadline,
                    star: data.star,
                    id: data.task_id,
                    column_orders: [
                        'column1',
                        'column2',
                        'column3',
                        'column4',
                        'column5',
                    ],
                    title: data.name,
                    content: data.note,
                    process: data.process,
                    editing: true,
                    created_at: data.create_time,
                    updated_at: '',
                    lstReportID: data.lstReportID,
                    lst_event_id: data.lst_event_id,
                    lst_object_id: data.lst_object_id,
                    lst_uid_receive: data.lst_uid_receive,
                    lst_hashtag: data.lst_hashtag,
                    lst_organ_receive_id: data.lst_organ_receive_id,
                    lst_media: data.lst_media,
                    status: data.status,
                    owner_id: data.owner_id,
                    background_url: data.background_url,
                }
                Board.push(value)
            })

            yield put(
                scrumBoardActions.setBoardData({
                    boards: Board,
                })
            )
        } else {
            yield put(
                scrumBoardActions.setBoardData({
                    boards: [],
                })
            )
        }
    } catch (ex) {
        console.log('search task  : ', ex.message)
    }
}

function* saga_searchTaskInfo(action) {
    try {
        const { page_number, text, status } = action.payload
        const request = yield call(searchTasks, page_number, 10, text, 6)
        console.log('search task request', request)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.updateTotalPage(request.total))
            const ListTask = request.data

            let Board = []
            yield ListTask.map(data => {
                let value = {
                    avatar: data.avatar,
                    deadline: data.deadline,
                    star: data.star,
                    id: data.task_id,
                    column_orders: [
                        'column1',
                        'column2',
                        'column3',
                        'column4',
                        'column5',
                    ],
                    title: data.name,
                    content: data.note,
                    process: data.process,

                    editing: true,
                    created_at: data.create_time,
                    updated_at: '',
                    lstReportID: data.lstReportID,
                    lst_event_id: data.lst_event_id,
                    lst_object_id: data.lst_object_id,
                    lst_uid_receive: data.lst_uid_receive,
                    lst_hashtag: data.lst_hashtag,
                    lst_organ_receive_id: data.lst_organ_receive_id,
                    lst_media: data.lst_media,
                    status: data.status,
                    owner_id: data.owner_id,
                    background_url: data.background_url,
                }
                Board.push(value)
            })

            yield put(
                scrumBoardActions.setBoardData({
                    boards: Board,
                })
            )
        } else {
            yield put(
                scrumBoardActions.setBoardData({
                    boards: [],
                })
            )
        }
    } catch (ex) {
        console.log('search task  : ', ex.message)
    }
}

function* saga_sentTaskToUser(action) {
    const { tid } = action.payload
    const request = yield call(sendTaskAPI, tid)
    if (request.error.code === 200) {
        notification.success({
            message: 'Đã gửi báo cáo đến các đơn vị',
        })
        yield put(scrumBoardActions.getDetailTaskById(tid))
    } else {
        HandleErrorCode(request.error.code)
    }
}

function* saga_updateReportRework(action) {
    const { fid, body } = action.payload
    const request = yield call(updateReportReworkAPI, fid, body)
    console.log('update report rework respone', request)
    if (request.error.code === 200) {
        notification.success({
            message: 'Sửa báo cáo thành công',
        })
    } else {
        HandleErrorCode(request.error.code)
    }
}

function* saga_getListCurrentEvent(action) {
    try {
        const { lst } = action.payload
        const request = yield call(getListEventQuery, lst)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.getListCurrentEventDone(request.data))
        }else{
            yield put(scrumBoardActions.getListCurrentEventDone([]))
        }
    } catch (ex) {
        console.log('get list event : ', ex.message)
    }
}

function* saga_commentReport(action) {
    try {
        const { body } = action.payload
        const request = yield call(commentReport, body)
        if (request.error.code === 200) {
            console.log('comment success')
        }
    } catch (ex) {
        console.log('comment report : ', ex.message)
    }
}
function* saga_getListCommentReport(action) {
    try {
        const { rid } = action.payload
        const request = yield call(getListReportComment, rid)
        if (request.error.code === 200) {
            const listId = []
            request.data.map(cmt => {
                listId.push(cmt.owner_id)
            })
            console.log('list id', listId)
            const requestUserComment = yield call(
                getListUser,
                listId.toString()
            )
            console.log('lrequestUserComment', requestUserComment)

            if (requestUserComment.error.code === 200) {
                yield put(
                    scrumBoardActions.updateListUserComment(
                        requestUserComment.data
                    )
                )
            }
            yield put(
                scrumBoardActions.getListCommentReportdone(
                    request.data,
                    rid,
                    request.total
                )
            )
        }
    } catch (ex) {
        console.log('get list comment : ', ex.message)
    }
}

function* saga_getListTaskStar(action) {
    try {
        const { page_number } = action.payload
        const request = yield call(getListTaskStar, page_number, 10)
        if (request.error.code === 200) {
            yield put(scrumBoardActions.updateTotalPage(request.total))
            const ListTask = request.data

            let Board = []
            yield ListTask.map(data => {
                let value = {
                    avatar: data.avatar,
                    deadline: data.deadline,
                    star: true,
                    id: data.task_id,
                    column_orders: [
                        'column1',
                        'column2',
                        'column3',
                        'column4',
                        'column5',
                    ],
                    title: data.name,
                    content: data.note,
                    process: data.process,
                    editing: true,
                    created_at: data.create_time,
                    updated_at: '',
                    lstReportID: data.lstReportID,
                    lst_event_id: data.lst_event_id,
                    lst_object_id: data.lst_object_id,
                    lst_uid_receive: data.lst_uid_receive,
                    lst_hashtag: data.lst_hashtag,
                    lst_organ_receive_id: data.lst_organ_receive_id,
                    lst_media: data.lst_media,
                    status: data.status,
                    owner_id: data.owner_id,
                    background_url: data.background_url,
                }
                Board.push(value)
            })

            yield put(
                scrumBoardActions.setBoardData({
                    boards: Board,
                })
            )
        }
    } catch (ex) {
        console.log('get list task star : ', ex.message)
    }
}

function* saga_deleteStarForTask(action) {
    try {
        const { taskid } = action.payload
        const request = yield call(DeleteStarForTask, taskid)
        if (request.error.code === 200) {
            console.log('delete star sucess')
        }
    } catch (ex) {
        console.log('delete star for task : ', ex.message)
    }
}

function* saga_makeStarForTask(action) {
    try {
        const { taskid } = action.payload
        const request = yield call(MakeStarForTask, taskid)
        console.log('make star req', request)

        if (request.error.code === 200) {
            console.log('make star sucess')
        }
    } catch (ex) {
        console.log('make star for task : ', ex.message)
    }
}

function* saga_changeStatusReport(action) {
    try {
        const {
            fromIndex,
            fromColumn,
            toIndex,
            toColumn,
            report_id,
            task_id,
        } = action.payload
        if (toColumn === 'column2') {
            const request = yield call(updateStatusReport, report_id, 'Sent')
            console.log('request update column ', request)
            if (request.error.code === 200) {
                console.log('update status success')
                yield put(scrumBoardActions.getDetailTaskById(task_id))
            } else {
                HandleErrorCode(request.error.code)
            }
        }
        if (toColumn === 'column3') {
            const request = yield call(updateStatusReport, report_id, 'Watched')
            console.log('request update column 2', report_id)
            if (request.error.code === 200) {
                console.log('update status success')
                yield put(scrumBoardActions.getDetailTaskById(task_id))
            } else {
                HandleErrorCode(request.error.code)
            }
        }
        if (toColumn === 'column4') {
            const request = yield call(updateStatusReport, report_id, 'Rework')

            if (request.error.code === 200) {
                console.log('update status success')
                yield put(scrumBoardActions.getDetailTaskById(task_id))
            } else {
                HandleErrorCode(request.error.code)
            }
        }
        if (toColumn === 'column5') {
            const request = yield call(
                updateStatusReport,
                report_id,
                'Approved'
            )

            if (request.error.code === 200) {
                console.log('update status success')
                yield put(scrumBoardActions.getDetailTaskById(task_id))
            } else {
                HandleErrorCode(request.error.code)
            }
        }
    } catch (ex) {
        console.log('change status report : ', ex.message)
    }
}

function* saga_CreateNewReport(action) {
    try {
        const { body } = action.payload

        const resquest = yield call(createNewReport, body)
        console.log('create new report respone', resquest)
        if (resquest.error.code === 200) {
            notification.success({
                message: 'Thêm báo cáo thành công',
            })
            yield put(scrumBoardActions.getDetailTaskById(body.task_id))
        } else {
            HandleErrorCode(resquest.error.code)
        }
    } catch (ex) {
        console.log('delete task Error : ', ex.message)
    }
}

function* saga_getDetailTaskById(action) {
    try {
        const { id } = action.payload

        const resquest = yield call(getTaskByIdAPI, id)
        console.log('request get detailTaskById', resquest)
        if (resquest.error.code === 200) {
            yield put(scrumBoardActions.setDataInfo(resquest.data))
            yield put(
                actions.action.getListOrgQueryById(
                    resquest.data.lst_organ_receive_id.toString()
                )
            )
        }
    } catch (ex) {
        console.log('delete get detailtask : ', ex.message)
    }
}

function* saga_setDataInfo(action) {
    const column = {
        column1: {
            id: 'column1',
            board_id: 'board-1',
            task_orders: [],
            title: 'Một số thông tin',
            editing: false,
        },
        column2: {
            id: 'column2',
            board_id: 'board-2',
            task_orders: [],
            title: 'Báo cáo hiện có',
            editing: false,
        },
        column3: {
            id: 'column3',
            board_id: 'board-1',
            task_orders: [],
            title: 'Báo cáo đã xem',
            editing: false,
        },
        column4: {
            id: 'column4',
            board_id: 'board-1',
            task_orders: [],
            title: 'Báo cáo cần làm lại',
            editing: false,
        },
        column5: {
            id: 'column5',
            board_id: 'board-1',
            task_orders: [],
            title: 'Báo cáo được chấp nhận',
            editing: false,
        },
    }
    yield put(scrumBoardActions.setBoardsData({ tasks: [], columns: column }))
    try {
        const { data } = action.payload

        let datastate = yield select()
        const columns = datastate.scrumBoard.columns
        //
        let value = {
            avatar: data.avatar,
            deadline: data.deadline,
            id: data.task_id,
            column_orders: [
                'column1',
                'column2',
                'column3',
                'column4',
                'column5',
            ],
            title: data.name,
            content: data.note,
            process: data.process,
            editing: true,
            created_at: data.create_time,
            updated_at: '',
            lstReportID: data.lstReportID,
            lst_event_id: data.lst_event_id,
            lst_object_id: data.lst_object_id,
            lst_uid_receive: data.lst_uid_receive,
            lst_hashtag: data.lst_hashtag,
            lst_organ_receive_id: data.lst_organ_receive_id,
            lst_media: data.lst_media,
            status: data.status,
            owner_id: data.owner_id,
            background_url: data.background_url,
        }
        console.log('data current board', value)
        yield put(scrumBoardActions.getDetailTaskByIdDone(value))
        //
        console.log('default value newboard', value)
        const listOwnerId = []

        const listTask = []
        if (data) {
            const info = {
                id: 'requireID',
                column_id: 'column1',
                title: data.name,
                description: data.note,
                labels: data.lst_hashtag,
                due_date: data.deadline,
                lst_event_id: data.lst_event_id,
                lst_hashtag: data.lst_hashtag,
                lst_object_id: data.lst_object_id,
                lst_organ_receive_id: data.lst_organ_receive_id,
                lst_uid_receive: data.lst_uid_receive,
                lst_media: data.lst_media,
                assignees: [],
                attachments: [],
                comments: [],
                todos: [],
                editing: false,
                created_at: data.create_time,
                updated_at: '',
                type: 'require',
                avatar: data.avatar,
                IdOfTask: data.task_id,
                process: data.process,
                status: data.status,
                owner_id: data.owner_id,
                background_url: data.background_url,
            }
            listTask.push(info)
            columns.column1.task_orders.push('requireID')
            listOwnerId.push(info.owner_id)
        }

        const resquest = yield call(
            getListReportQueryById,
            data.lstReportID.toString()
        )
        console.log('ListCurrentReport', resquest.data)
        //get report
        if (resquest.error.code === 200) {
            console.log('report data', resquest.data)
            resquest.data.map(report => {
                const reportTask = {
                    id: report.report_id,
                    column_id: getColumnId(report.status_report),
                    title: report.title,
                    description: report.content,
                    labels: report.hashtag,
                    due_date: null,
                    assignees: [],
                    attachments: [],
                    comments: [],
                    todos: [],
                    editing: false,
                    created_at: report.created_time,
                    updated_at: '',
                    type: 'report',
                    event: report.event,
                    media: report.media,
                    object: report.object,
                    organ_create: report.organ_create,
                    canEdit: report.status_report === 'Rework' ? true : false,
                    IdOfTask: data.task_id,
                    score: report.score,
                    owner_id: report.owner_id,
                }
                listOwnerId.push(report.owner_id)
                listTask.push(reportTask)
                if (report.status_report === 'Sent') {
                    console.log('columns.column2', columns.column2)
                    columns.column2.task_orders.push(report.report_id)
                }
                if (report.status_report === 'Watched') {
                    columns.column3.task_orders.push(report.report_id)
                }
                if (report.status_report === 'Rework') {
                    columns.column4.task_orders.push(report.report_id)
                }
                if (report.status_report === 'Approved') {
                    columns.column5.task_orders.push(report.report_id)
                }
            })
        }
        console.log('list data task', listTask)
        console.log('list data colum', columns)
        const requestListUserInfo = yield call(
            getListUser,
            listOwnerId.toString()
        )
        if (requestListUserInfo.error.code === 200) {
            yield put(
                scrumBoardActions.updateListCurrentUserInfo(
                    requestListUserInfo.data
                )
            )
        }
        yield put(
            scrumBoardActions.setBoardsData({
                columns: columns,
                tasks: listTask,
            })
        )
    } catch (ex) {
        console.log('set data info Error : ', ex.message)
    }
}

function* saga_deleteTask(action) {
    try {
        const { id, history } = action.payload

        const resquest = yield call(updateTaskStatusAPI, id, 5)
        console.log('request data', resquest)
        if (resquest.error.code === 200) {
            notification.success({
                message: 'Xoá nhiệm vụ thành công',
            })
            history.push(`/app/qbtask`)
        } else {
            HandleErrorCode(resquest.error.code)
        }
    } catch (ex) {
        console.log('delete task Error : ', ex.message)
    }
}

function* saga_createNewTask(action) {
    try {
        const { body, history } = action.payload

        const resquest = yield call(createNewTask, body)
        console.log('request data', resquest)
        if (resquest.error.code === 200) {
            notification.success({
                message: 'Tạo mới nhiệm vụ thành công',
            })
            history.push(`/app/qbtask/project/${resquest.data}`)
            yield put(scrumBoardActions.visibleModalCreateTaskAction(false))
        }
    } catch (ex) {
        console.log('update task Error : ', ex.message)
    }
}

function* saga_updateTask(action) {
    try {
        const { body, taskid, history } = action.payload
        console.log('do update task', taskid)
        console.log('do update task body', body)

        const resquest = yield call(updateTaskAPI, taskid, body)
        console.log('update task reuest', resquest)
        if (resquest.error.code === 200) {
            notification.success({
                message: 'Cập nhật nhiệm vụ thành công',
            })
            if (history) {
                history.push(`/app/qbtask`)
            }
        } else {
            HandleErrorCode(resquest.error.code)
        }
    } catch (ex) {
        console.log('update task Error : ', ex.message)
    }
}

function* saga_getListBoard(action) {
    try {
        const { page_number, isGetAll } = action.payload
        const userInfo = yield select(state => state.auth.userInfo)
        console.log('userinfo list board', userInfo)

        let isHavePermission = yield userInfo.actions.find(data => {
            return data === 'TASK_VIEW'
        })
        console.log('isHavePermission', isHavePermission)
        let resquest
        if (isHavePermission || userInfo.tier_id === 100) {
            resquest = yield call(getListTask, page_number, 10, isGetAll)
        } else {
            resquest = yield call(
                getListTaskOfUser,
                userInfo.uid,
                page_number,
                10,
                isGetAll
            )
        }
        console.log('data list board', resquest)

        if (resquest.error.code === 200) {
            yield put(scrumBoardActions.updateTotalPage(resquest.total))
            const ListTask = resquest.data
            console.log('ListTask')

            let Board = []
            yield ListTask.map(data => {
                let value = {
                    avatar: data.avatar,
                    deadline: data.deadline,
                    star: data.star,
                    id: data.task_id,
                    column_orders: [
                        'column1',
                        'column2',
                        'column3',
                        'column4',
                        'column5',
                    ],
                    title: data.name,
                    content: data.note,
                    process: data.process,
                    editing: true,
                    created_at: data.create_time,
                    updated_at: '',
                    lstReportID: data.lstReportID,
                    lst_event_id: data.lst_event_id,
                    lst_object_id: data.lst_object_id,
                    lst_uid_receive: data.lst_uid_receive,
                    lst_hashtag: data.lst_hashtag,
                    lst_organ_receive_id: data.lst_organ_receive_id,
                    lst_media: data.lst_media,
                    status: data.status,
                    owner_id: data.owner_id,
                    background_url: data.background_url,
                }
                Board.push(value)
            })

            console.log('data board', Board)
            yield put(
                scrumBoardActions.setBoardData({
                    boards: Board,
                })
            )
        } else {
            yield put(
                scrumBoardActions.setBoardData({
                    boards: [],
                })
            )
        }
    } catch (ex) {
        console.log('get lisst task Error : ', ex.message)
    }
}

function* createOrUpdateBoardEffectSaga(action) {
    let scrum_boards = yield select(getScrumBoards)
    const boards = {
        ...scrum_boards.boards,
        [action.payload.id]: action.payload,
    }
    scrum_boards = {
        columns: scrum_boards.columns,
        tasks: scrum_boards.tasks,
        boards: boards,
    }
    saveState('scrum_boards', scrum_boards)

    yield put(scrumBoardActions.createOrUpdateBoard(boards))
}

function* deleteBoardEffectSaga(action) {
    let scrum_boards = yield select(getScrumBoards)
    const BOARDS = {
        ...scrum_boards.boards,
    }
    delete BOARDS[action.payload]

    const boards = BOARDS

    scrum_boards = {
        ...scrum_boards,
        boards,
    }
    saveState('scrum_boards', scrum_boards)

    yield put(scrumBoardActions.deleteBoard(boards))
}

function* createOrUpdateColumnEffectSaga({ payload: { column, board_id } }) {
    let scrum_boards = yield select(getScrumBoards)
    console.log(column, board_id)
    const columns = {
        ...scrum_boards.columns,
        [column.id]: {
            ...column,
            editing: false,
        },
    }
    let boards = scrum_boards.boards
    if (!column.editing) {
        boards = {
            ...scrum_boards.boards,
            [board_id]: {
                ...scrum_boards.boards[board_id],
                column_orders: [
                    ...scrum_boards.boards[board_id].column_orders,
                    column.id,
                ],
            },
        }
    }
    scrum_boards = {
        ...scrum_boards,
        columns,
        boards,
    }
    saveState('scrum_boards', scrum_boards)
    yield put(scrumBoardActions.createOrUpdateColumn({ columns, boards }))
}

function* deleteColumnEffectSaga({ payload: { column_id, board_id } }) {
    let scrum_boards = yield select(getScrumBoards)
    const COLUMNS = {
        ...scrum_boards.columns,
    }
    delete COLUMNS[column_id]

    const columns = COLUMNS
    const boards = {
        ...scrum_boards.boards,
        [board_id]: {
            ...scrum_boards.boards[board_id],
            column_orders: scrum_boards.boards[board_id].column_orders.filter(
                order => order !== column_id
            ),
        },
    }

    scrum_boards = {
        ...scrum_boards,
        columns,
        boards,
    }
    saveState('scrum_boards', scrum_boards)

    yield put(scrumBoardActions.deleteColumn({ columns, boards }))
}

function* moveColumnEffectSaga({ payload: { board_id, column_orders } }) {
    let scrum_boards = yield select(getScrumBoards)
    const boards = {
        ...scrum_boards.boards,
        [board_id]: {
            ...scrum_boards.boards[board_id],
            column_orders: column_orders,
        },
    }
    scrum_boards = {
        ...scrum_boards,
        boards: boards,
    }
    saveState('scrum_boards', scrum_boards)

    yield put(scrumBoardActions.setMovedColumn(boards))
}

function* createOrUpdateTaskEffectSaga(action) {
    let scrum_boards = yield select(getScrumBoards)
    const tasks = {
        ...scrum_boards.tasks,
        [action.payload.id]: { ...action.payload, editing: false },
    }
    let columns = scrum_boards.columns
    if (!action.payload.editing) {
        columns = {
            ...scrum_boards.columns,
            [action.payload.column_id]: {
                ...scrum_boards.columns[action.payload.column_id],
                task_orders: [
                    ...scrum_boards.columns[action.payload.column_id]
                        .task_orders,
                    action.payload.id,
                ],
            },
        }
    }

    scrum_boards = {
        columns: columns,
        tasks: tasks,
        boards: scrum_boards.boards,
    }
    saveState('scrum_boards', scrum_boards)

    yield put(scrumBoardActions.createOrUpdateTask({ tasks, columns }))
}

function* deleteTaskEffectSaga({ payload: { task_id, column_id } }) {
    let scrum_boards = yield select(getScrumBoards)
    const tasks = Object.keys(scrum_boards.tasks).reduce((object, key) => {
        if (key !== task_id) {
            object[key] = scrum_boards.tasks[key]
        }
        return object
    }, {})
    const columns = {
        ...scrum_boards.columns,
        [column_id]: {
            ...scrum_boards.columns[column_id],
            task_orders: scrum_boards.columns[column_id].task_orders.filter(
                order => order !== task_id
            ),
        },
    }
    scrum_boards = {
        columns: columns,
        tasks: tasks,
        boards: scrum_boards.boards,
    }
    saveState('scrum_boards', scrum_boards)
    yield put(scrumBoardActions.deleteTask({ columns, tasks }))
}

function* moveTaskEffectSaga({ payload: { tasks, columns } }) {
    let scrum_boards = yield select(getScrumBoards)
    scrum_boards = {
        columns: columns,
        tasks: tasks,
        boards: scrum_boards.boards,
    }
    saveState('scrum_boards', scrum_boards)
    yield put(scrumBoardActions.setMovedTask({ columns, tasks }))
}

export default function* scrumBoardSaga() {
    yield all([
        takeEvery(scrumBoardActions.LOAD_BOARDS_DATA_SAGA, saga_getListBoard),

        takeEvery(
            scrumBoardActions.CREATE_OR_UPDATE_BOARD_WATCHER,
            createOrUpdateBoardEffectSaga
        ),
        takeEvery(
            scrumBoardActions.DELETE_BOARD_WATCHER,
            deleteBoardEffectSaga
        ),
        takeEvery(
            scrumBoardActions.CREATE_OR_UPDATE_COLUMN_WATCHER,
            createOrUpdateColumnEffectSaga
        ),
        takeEvery(
            scrumBoardActions.DELETE_COLUMN_WATCHER,
            deleteColumnEffectSaga
        ),
        takeEvery(scrumBoardActions.MOVE_COLUMN_WATCHER, moveColumnEffectSaga),
        takeEvery(
            scrumBoardActions.CREATE_OR_UPDATE_TASK_WATCHER,
            createOrUpdateTaskEffectSaga
        ),
        takeEvery(scrumBoardActions.DELETE_TASK_WATCHER, deleteTaskEffectSaga),
        takeEvery(scrumBoardActions.MOVE_TASK_WATCHER, moveTaskEffectSaga),
        takeEvery(scrumBoardActions.UPDATE_TASK, saga_updateTask),
        takeEvery(scrumBoardActions.CREATE_NEW_TASK, saga_createNewTask),
        takeEvery(scrumBoardActions.DELETE_TASK_ACTION, saga_deleteTask),
        takeEvery(scrumBoardActions.SET_DATA_INFO, saga_setDataInfo),
        takeEvery(
            scrumBoardActions.GET_DETAIL_TASK_BY_ID,
            saga_getDetailTaskById
        ),
        takeEvery(scrumBoardActions.CREATE_NEW_REPORT, saga_CreateNewReport),
        takeEvery(scrumBoardActions.MOVE_CARD_REPORT, saga_changeStatusReport),
        takeEvery(scrumBoardActions.MAKE_STAR_FOR_TASK, saga_makeStarForTask),
        takeEvery(
            scrumBoardActions.DELETE_STAR_FOR_TASK,
            saga_deleteStarForTask
        ),
        takeEvery(scrumBoardActions.GET_LIST_TASK_STAR, saga_getListTaskStar),
        takeEvery(
            scrumBoardActions.GET_LIST_COMMENT,
            saga_getListCommentReport
        ),
        takeEvery(scrumBoardActions.COMMENT_REPORT, saga_commentReport),
        takeEvery(
            scrumBoardActions.GET_LIST_CURRENT_EVENT,
            saga_getListCurrentEvent
        ),
        takeEvery(
            scrumBoardActions.UPDATE_REPORT_REWORK,
            saga_updateReportRework
        ),
        takeEvery(scrumBoardActions.SENT_TASK_TO_USER, saga_sentTaskToUser),
        takeEvery(scrumBoardActions.SEARCH_TASK_INFO, saga_searchTaskInfo),
        takeEvery(
            scrumBoardActions.GET_ACTIVITY_TASK,
            saga_getListTaskActivity
        ),
        takeEvery(scrumBoardActions.UPDATE_STATUS_TASK, saga_updateStatusTask),
        takeEvery(
            scrumBoardActions.UPDATE_SCORE_REPORT,
            saga_updateScoreReport
        ),
        takeEvery(
            scrumBoardActions.GET_LIST_RANKING_IN_TASK,
            saga_getListRankingInTask
        ),
        takeEvery(
            scrumBoardActions.GET_LIST_TASK_BY_HASH_TAG,
            saga_searchTaskByHashTag
        ),
        takeEvery(
            scrumBoardActions.GET_LIST_TASK_ABOUT_TIME,
            saga_getListTaskAboutTime
        ),
        takeEvery(
            scrumBoardActions.GET_LIST_TASK_MERGE_OPTION,
            saga_getListTaskMergeOption
        ),
        takeEvery(
            scrumBoardActions.GET_LIST_HASH_TAG_ALL,
            saga_getListHashTagAll
        ),
        takeEvery(
            scrumBoardActions.SEARCH_USER_BY_TEXT,
            saga_searchUserByText
        ),
        takeEvery(
            scrumBoardActions.GET_LIST_CURRENT_USER,
            saga_getCurrentListUser
        ),
        
        
    ])
}
